import React, { useEffect, useRef, useState } from 'react';
import styles from './Select.module.css';

export default function Select({
    label,
    value,
    options,
    onChange,
    disabled,
    error,
    helperText,
    placeholder = '',
    className,
}) {
    const [aberto, setAberto] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const fecharAoClicarFora = (evento) => {
            if (wrapperRef.current && !wrapperRef.current.contains(evento.target)) setAberto(false);
        };
        document.addEventListener('mousedown', fecharAoClicarFora);
        return () => document.removeEventListener('mousedown', fecharAoClicarFora);
    }, []);

    const selecionada = options.find((opcao) => opcao.value === value);
    const rotuloElevado = aberto || Boolean(selecionada) || Boolean(placeholder);

    const selecionar = (opcao) => {
        onChange(opcao.value);
        setAberto(false);
    };

    return (
        <div className={`${styles.wrapper} ${className || ''}`} ref={wrapperRef}>
            <button
                type="button"
                role="combobox"
                aria-expanded={aberto}
                disabled={disabled}
                className={`${styles.campo} ${aberto ? styles.campoAberto : ''} ${error ? styles.campoComErro : ''}`}
                onClick={() => setAberto((anterior) => !anterior)}
                onKeyDown={(evento) => evento.key === 'Escape' && setAberto(false)}
            >
                <span className={styles.valor}>{selecionada?.label ?? placeholder}</span>
                <i className={`fa fa-chevron-down ${styles.seta} ${aberto ? styles.setaAberta : ''}`} />
            </button>

            {label && (
                <span className={`${styles.rotulo} ${rotuloElevado ? styles.rotuloElevado : ''} ${error ? styles.rotuloComErro : ''}`}>
                    {label}
                </span>
            )}

            {aberto && (
                <div className={styles.menu} role="listbox">
                    {options.map((opcao) => (
                        <button
                            type="button"
                            role="option"
                            aria-selected={opcao.value === value}
                            key={String(opcao.value)}
                            className={`${styles.opcao} ${opcao.value === value ? styles.opcaoAtiva : ''}`}
                            onClick={() => selecionar(opcao)}
                        >
                            {opcao.label}
                        </button>
                    ))}
                </div>
            )}

            {helperText && <p className={`${styles.ajuda} ${error ? styles.ajudaComErro : ''}`}>{helperText}</p>}
        </div>
    );
}
